import { useDica } from '../ui/Dica.js';

/**
 * Barras verticais, com pares. Portado de `bars()` no protótipo.
 *
 * "Com pares" é o que faz este gráfico servir a três telas diferentes:
 * presenças contra faltas, entradas contra saídas, e uma série só nas
 * vendas do bar. A altura é percentual sobre o maior valor da série
 * inteira — não por coluna —, senão colunas de grandezas diferentes
 * pareceriam iguais.
 */

export interface ColunaDeBarras {
  /** O rótulo do eixo: "S1", "Qua", "Sem 1". */
  readonly x: string;
  readonly valores: readonly number[];
  /** Uma dica por valor. Aceita <br> e <em>. */
  readonly dicas: readonly string[];
}

export function Barras({
  colunas,
  cores,
  maximo,
  legenda,
}: {
  colunas: readonly ColunaDeBarras[];
  /** Uma cor por posição do par. */
  cores: readonly string[];
  maximo?: number;
  legenda?: readonly { rotulo: string; cor: string }[];
}) {
  const dica = useDica();
  const teto = maximo ?? Math.max(...colunas.flatMap((c) => c.valores), 1);

  return (
    <div>
      <div className="bars">
        {colunas.map((coluna) => (
          <div className="col" key={coluna.x}>
            <div className="pair">
              {coluna.valores.map((valor, i) => (
                <div
                  key={i}
                  className="b"
                  style={{
                    // 3% de piso: uma barra de valor zero precisa
                    // continuar visível, ou a coluna parece ausente.
                    height: `${Math.max(3, (valor / teto) * 100)}%`,
                    background: cores[i] ?? cores[0],
                  }}
                  onMouseEnter={(e) =>
                    dica.mostrar(e, { titulo: coluna.x, texto: coluna.dicas[i] ?? '' })
                  }
                  onMouseMove={(e) => dica.mover(e)}
                  onMouseLeave={() => dica.esconder()}
                />
              ))}
            </div>
            <div className="x">{coluna.x}</div>
          </div>
        ))}
      </div>

      {legenda && (
        <div className="legend-row">
          {legenda.map((l) => (
            <span key={l.rotulo}>
              <i style={{ background: l.cor }} />
              {l.rotulo}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
